import React from 'react'
import { Grid, Typography, Link as MuiLink } from '@mui/material'
import { Link } from '../../../../../../../components'
import useExternalApp from '../../../../../../../hooks/useExternalApp'
import { routes } from '../../../../../../../routes'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  root: {
    height: 400,
    backgroundColor: '#f8f9fd'
  },
  title: {
    ...typography.heading.h5,
    fontWeight: typography.fontWeightMedium,
    color: palette.common.black,
    marginBottom: spacing(1)
  },
  subtitle: {
    ...typography.body.l,
    color: palette.common.black,
    marginBottom: spacing(4)
  },
  body: {
    ...typography.body.m,
    color: palette.common.black,
    marginBottom: spacing(4)
  },
  link: {
    ...typography.body.m
  }
}))

const CancelCompletePage = props => {
  const classes = useStyles()
  const { getMtUrl } = useExternalApp()
  return (
    <Grid
      container
      direction='column'
      justifyContent='center'
      alignItems='center'
      className={classes.root}
      data-test='retention-cancel-complete'
    >
      <Typography align='center' className={classes.title}>
        Your subscription has been canceled.
      </Typography>
      <Typography align='center' className={classes.body}>
        There will not be any new charges on your account. If you have any questions feel free to
        contact us{' '}
        <MuiLink href={getMtUrl('contact')} color='primary' underline='always'>
          here.
        </MuiLink>
      </Typography>
      <Link
        to={routes.home.path}
        color='primary'
        underline='always'
        className={classes.link}
        data-test='retention-cancel-complete-home'
      >
        Return to home page
      </Link>
    </Grid>
  )
}

export default CancelCompletePage
